// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"467":"823f40c6","615":"8a5f89a8","634":"57c2a965","645":"c2afeb5f","721":"823f40c6"}[chunkId] + ".css";
};